<template>
    <b-card no-body>

        <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-proficiency-create-or-update v-model="proficiency" :errors="errors"></employee-proficiency-create-or-update>
            <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>

        <v-table    ref="table"
                    :buttons="buttons"
                    :fields="fields"
                    name="employee-proficiency"
                    search
                    pagination="server"
                    :items-provider="provider"
                    :add-callback="createNew"></v-table>

    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeProficiencyCreateOrUpdate from './components/EmployeeProficiencyCreateOrUpdate.vue';
import HumanResourcesParameterApi from '@/api/human-resources-parameters';
export default {
    components:{
        BCard,
        EmployeeProficiencyCreateOrUpdate
    },
    data(){
        return {
            fields:[
                {name:"Yetkinlik",key:"Name", thClass:"w-100",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            loading:false,
            errors:{},
            proficiency:{
                Id:null,
                Name:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.proficiency.Id = null
            this.proficiency.Name = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.EmployeeProficiency.Table(data)
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.EmployeeProficiency.CreateOrUpdate(this.editing,this.proficiency).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.proficiency.Id = item.Id
            this.proficiency.Name = item.Name
            this.$showModal('create-or-update')
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} maliyet merkezini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.EmployeeProficiency.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>